export default {
	async addNewLeague(context, payload) {
		const token = localStorage.getItem('token');
		const userId = context.rootGetters.userId;
		const leagueInfo = {
			league: payload.league,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/users/${userId}.json?auth=` + token,
			{
				method: 'PATCH',
				body: JSON.stringify(leagueInfo),
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch leagues.');
			throw error;
		}
		const response2 = await fetch(`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues.json?auth=` + token, {
			method: 'POST',
			body: JSON.stringify(leagueInfo),
		});
		const responseData2 = await response2.json();
		if (!response2.ok) {
			const error = new Error(responseData2.message || 'Failed to fetch leagues.');
			throw error;
		}
		localStorage.setItem('leagueId', responseData2.leagueId);
		context.commit('setLeague', {
			league: responseData.league,
		});
	},
	async fetchLeagues(context) {
		const token = localStorage.getItem('token');
		const response = await fetch(`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues.json?auth=` + token);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		const leagues = [];

		for (const key in responseData) {
			const league = {
				id: key,
				league: responseData[key].league,
			};
			leagues.push(league);
		}
		context.commit('setLeague', leagues);
	},
	async newSchedule(context, payload) {
		const token = localStorage.getItem('token');
		const userLeagueId = localStorage.getItem('leagueId');
		const divisionId = payload.divisionId
		const schedule = {
			season: payload.season,
			schedule: payload.schedule,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeagueId}/divisions/${divisionId}/schedules.json?auth=` +
				token,
			{
				method: 'POST',
				body: JSON.stringify(schedule),
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch leagues.');
			throw error;
		}
		context.commit('addNewSchedule', schedule);
	},
	async fetchSchedules(context, payload) {
		const token = localStorage.getItem('token');
		const userLeagueId = localStorage.getItem('leagueId');
		const divisionId = payload.divisionId
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeagueId}/divisions/${divisionId}/schedules.json?auth=` +
				token
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		const schedules = [];

		for (const key in responseData) {
			const schedule = {
				id: key,
				schedule: responseData[key].schedule,
				season: responseData[key].season,
			};
			schedules.push(schedule);
		}
		context.commit('setSchedules', schedules);
	},
	async addNewDivision(context, payload) {
		const token = localStorage.getItem('token');
		const userLeagueId = localStorage.getItem('leagueId');
		const division = {
			division: payload.division,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeagueId}/divisions.json?auth=` + token,
			{
				method: 'POST',
				body: JSON.stringify(division),
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch leagues.');
			throw error;
		}
		context.commit('addNewDivision', division);
	},
	async fetchDivisions(context, payload) {
		const token = localStorage.getItem('token');
		const userLeagueId = localStorage.getItem('leagueId');
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeagueId}/divisions.json?auth=` + token
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		const divisions = [];

		for (const key in responseData) {
			const division = {
				id: key,
				division: responseData[key].division,
			};
			divisions.push(division);
		}
		context.commit('setDivisions', divisions);
	},
	async fetchSignUpDivisions(context, payload) {
		const token = localStorage.getItem('token');
		const userLeagueId = payload.leagueId
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeagueId}/divisions.json?auth=` + token
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		const divisions = [];

		for (const key in responseData) {
			const division = {
				id: key,
				division: responseData[key].division,
			};
			divisions.push(division);
		}
		context.commit('setDivisions', divisions);
	},
};
